import React from 'react';

import ShareAccountsForm from './ShareAccountsForm';

export { LOOKALIKE_AUDIENCE } from './constants';

const ShareAccounts = ({ initialValues, onSubmit, ...props }) => {
  return (
    <ShareAccountsForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      {...props}
    />
  );
};

export default ShareAccounts;
